import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { RatingModule } from '@shared/components/rating/rating.module';
import { MultiSelectModule } from '@shared/components/multi-select/multi-select.module';
import { SvgModule } from '@shared/components/svg/svg.module';
import { LoaderModule } from '@shared/components/loader/loader.module';
import { BackwardBtnModule } from '@shared/components/backward-btn/backward-btn.module';
import { SelectModule } from '@shared/components/select/select.module';
import { MapModule } from '@shared/components/map/map.module';
import { FilterCatalogItemsModule } from '@shared/components/filter-catalog-items/filter-catalog-items.module';
import { ErrorPageMessageModule } from '@shared/components/error-page-message/error-page-message.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HoverableSvgModule } from '@shared/components/hoverable-svg/hoverable-svg.module';
import { NumericInputModule } from '@shared/components/numeric-input/numeric-input.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicUpdateInfoModule } from '@shared/components/dynamic-update-info/dynamic-update-info.module';
import { MatPaginationCustomModule } from '@shared/components/mat-pagination-custom/mat-pagination-custom.module';
import { CustomToolTipModule } from '@shared/directives/custom-tool-tip/custom-tool-tip.module';
import { PassportModule } from '@shared/components/passport/passport.module';
import { SearchInputModule } from '@shared/components/search-input/search-input.module';
import { PxModule } from '@shared/pipes/px/px.module';
import { CatalogItemsDataMainComponent } from './components/main/catalog-items-data-main.component';
import { HeaderComponent } from './components/header/header.component';
import { CatalogItemsComponent } from './components/catalog-items/catalog-items.component';
import { CatalogItemsDataRoutingModule } from './catalog-items-data-routing.module';
import { CatalogDescriptionComponent } from './components/description/catalog-description.component';
import { CatalogMapComponent } from './components/catalog-map/catalog-map.component';
import { CatalogItemCardComponent } from './components/catalog-item-card/catalog-item-card.component';
import { CatalogItemCardInfoModule } from '../../shared/components/catalog-item-card-info/catalog-item-card-info.module';
import { DownloadButtonModule } from '../../shared/components/download-button/download-button.module';
import { MoreVertMenuModule } from '../../shared/components/more-vert-menu/more-vert-menu.module';
import { ColumnFilterComponent } from './components/column-filter/column-filter.component';
import { FavoritesAndSubscribeCatalogModule } from '../../shared/components/favorites-and-subscribe-catalog/favorites-and-subscribe-catalog.module';
import { CatalogPassportTabComponent } from './components/catalog-passport-tab/catalog-passport-tab.component';
import { DownloadLinkModule } from '../../shared/components/download-link/download-link.module';
import { CatalogItemsDataService } from './components/catalog-items/catalog-items-data.service';
import { CatalogItemsPipesModule } from './components/catalog-items/pipes/catalog-items-pipes.module';
import { DownloadLinkListModule } from '../../shared/components/download-link-list/download-link-list.module';

@NgModule({
  declarations: [
    CatalogItemsDataMainComponent,
    HeaderComponent,
    CatalogItemsComponent,
    CatalogDescriptionComponent,
    CatalogMapComponent,
    CatalogItemCardComponent,
    ColumnFilterComponent,
    CatalogPassportTabComponent,
  ],
  exports: [CatalogItemsComponent, CatalogItemCardComponent],
  imports: [
    FilterCatalogItemsModule,
    CommonModule,
    CatalogItemsDataRoutingModule,
    MatTabsModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    OverlayModule,
    FormsModule,
    ClipboardModule,
    SelectModule,
    SvgModule,
    CatalogItemCardInfoModule,
    DownloadButtonModule,
    MoreVertMenuModule,
    MultiSelectModule,
    RatingModule,
    NgLetModule,
    LoaderModule,
    BackwardBtnModule,
    MapModule,
    ErrorPageMessageModule,
    MatTooltipModule,
    HoverableSvgModule,
    NumericInputModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    TranslateModule,
    FavoritesAndSubscribeCatalogModule,
    DynamicUpdateInfoModule,
    MatPaginationCustomModule,
    CustomToolTipModule,
    PassportModule,
    SearchInputModule,
    DownloadLinkModule,
    CatalogItemsPipesModule,
    PxModule,
    DownloadLinkListModule
  ],
  providers: [CatalogItemsDataService],
})
export class CatalogItemsDataModule {}
